import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.completed != this.props.completed) {
            return true;
        }

        if (this.props.upc != 'yes-or-no-tarot-redux' && nextProps.next_position != this.props.next_position) {
            return true;
        }

        return false;
    }

    render() {
        if (!this.props.completed) {
            if (this.props.upc == 'yes-or-no-tarot-redux' || !this.props.next_position) {
                return (
                    <h2 className='card-next'>Choose card:</h2>
                );
            }

            return (
                <h2 className='card-next'>
                    Choose {this.props.next_position.title.replace(/\/.*/, '')} card:
                </h2>
            );
        }

        return (
            <h2 className='card-next'>All Cards Chosen</h2>
        );
    }
}

const mapStateToProps = (state) => ({
    completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
    next_position: state['tarot-reading'].positions[state['tarot-reading'].cards.length],
});

export default connect(mapStateToProps)(Component);